import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { HomeComponent } from './components/home/home.component';
import { AdminAuthGuard } from './services/admin-auth-guard';
import { AdminComponent } from './components/admin/admin.component';
import { StateIndexComponent } from './components/admin/state/index/state-index.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,TopBarComponent,HomeComponent, AdminComponent, StateIndexComponent],
  providers:[AdminAuthGuard],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'NesiyaTovaPortal';
  newUrl: boolean = false;


  ngOnInit(): void {
      this.newUrl = false;
  }
}
